import {
  CreateUserAccountDto,
  CreateUserAccountResponse,
  UpdateUserRequest,
  UpdateUserResponse,
  UploadProfileImageResponse,
  User,
  UserDetailsResponse,
  UserFirstStepsDto,
  UserFirstStepsResponse,
} from "../@types/Users";
import {
  create,
  getDetails,
  firstSteps,
  update,
  uploadImage,
} from "../services/user/account";

export function useUser() {
  function isAuthenticated(): boolean {
    const apiToken = localStorage.getItem("auth_token");

    if (apiToken) {
      return true;
    }

    return false;
  }

  function isUserAlreadyInvoiced(): boolean {
    const isInvoiced = localStorage.getItem("is_user_invoiced");

    if (isInvoiced) {
      return true;
    }

    return false;
  }

  async function createAccount(
    dto: CreateUserAccountDto
  ): Promise<CreateUserAccountResponse | null> {
    const response = await create(dto);
    const timestamp = new Date().getTime().toString();

    if (response && response.data?.token) {
      localStorage.setItem("auth_token", response.data.token);
      localStorage.setItem("auth_token_created_at", timestamp);
    }

    return response;
  }

  async function getUserDetails(): Promise<UserDetailsResponse | null> {
    const response = await getDetails();

    if (response) {
      const { status, data: userData } = response;

      if (status === 1) {
        localStorage.setItem("userDetails", JSON.stringify(userData));

        return response;
      }
    }

    return null;
  }

  /**
   * Get user details from cache, if no cache then do an API Call.
   */
  async function getUserDetailsWithCache(): Promise<User | null> {
    const cachedUserDetails = localStorage.getItem("userDetails");

    if (!cachedUserDetails) {
      const userDetailsResponse = await getUserDetails();

      if (userDetailsResponse?.data) {
        return userDetailsResponse.data;
      }
    } else {
      return JSON.parse(cachedUserDetails);
    }

    return null;
  }

  async function reloadUserCachedDetails(): Promise<boolean> {
    const reloadedUserDetails = await getUserDetails();

    if (reloadedUserDetails) {
      return true;
    }

    return false;
  }

  async function storeFirstSteps(
    dto: UserFirstStepsDto
  ): Promise<UserFirstStepsResponse | null> {
    return firstSteps(dto);
  }

  async function getAssets() {
    const userDetails = await getUserDetailsWithCache();

    if (userDetails?.preferences?.assets) {
      try {
        const userAssets = JSON.parse(userDetails.preferences.assets);
        return userAssets;
      } catch (error) {
        return null;
      }
    }

    return null;
  }

  async function updateUserDetails(
    dto: UpdateUserRequest
  ): Promise<UpdateUserResponse | null> {
    return update(dto);
  }

  async function uploadProfileImage(
    file: File
  ): Promise<UploadProfileImageResponse | null> {
    const formData = new FormData();
    formData.append("file", file);

    return uploadImage(formData);
  }

  return {
    isAuthenticated,
    isInvoiced: isUserAlreadyInvoiced,
    createAccount,
    getUserDetails,
    storeFirstSteps,
    getUserDetailsWithCache,
    getAssets,
    reloadUserCachedDetails,
    updateUserDetails,
    uploadProfileImage,
  };
}
